import { Button } from '@mantine/core';
import { IconFileTypePdf } from '@tabler/icons-react';

import { getEvaluationDepartmentSummaryPdfFileDownloadUrl } from '@/module/Evaluation/model/EvaluationApi';

import { Id } from '@feature/utils';

interface EvaluationDepartmentSummaryButtonProps {
  evaluationId: Id;
  departmentId: Id;
}

const onDownload = (evaluationId: Id, departmentId: Id) => {
  window.open(getEvaluationDepartmentSummaryPdfFileDownloadUrl(evaluationId, departmentId));
};

export function EvaluationDepartmentSummaryPdfButton({
  evaluationId,
  departmentId,
}: EvaluationDepartmentSummaryButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypePdf size="24px" />}
      onClick={() => onDownload(evaluationId, departmentId)}
    >
      Descarcă centralizare PDF - FARĂ semnătură
    </Button>
  );
}
